import React from 'react';
import { __ } from '../../../assets/javascripts/library.js';
import NavigationBar from "./components/navigator.jsx";
import Overview from "./partials/overview.jsx";
import { ToasterProvider } from "../global-components/toaster.jsx";

const { inertial_data } = window.solea_data;

function EventOverview() {
    return (
    <ToasterProvider>
        <div>
            <h2>{inertial_data.event.event_name} ( {inertial_data.event.date_begin} - {inertial_data.event.date_end} )</h2>

            <div id="solea_event_contents">
                <NavigationBar event_data={inertial_data.event}/>

                <div id="solea_event_details_content">
                    <div id="area_overview" className="container_visible">
                        <ToasterProvider>
                            <div id="solea_event_overview_contents">
                                <Overview link="overview" result={inertial_data} />
                            </div>
                        </ToasterProvider>
                    </div>

                    <div id="area_all_participants" className="container_hidden">

                    </div>

                    <div id="area_localgroup_participants" className="container_hidden">

                    </div>

                    <div id="area_participationgroup_participants" className="container_hidden">

                    </div>

                    <div id="area_signedoff_participants" className="container_hidden">

                    </div>

                    <div id="area_addons" className="container_hidden">

                    </div>
                </div>
            </div>
        </div>
    </ToasterProvider>

);
}

export default EventOverview;
